import { memo } from "react";
import { when } from "util/support";
import { convertToOptions } from "util/transformers";
import { getOptionId } from "util/option";
import CountrySelector, { useAdapter } from "ui/widgets/CountrySelector";
import type { CountryFilterProps } from "./types";

const CountryFilter = ({
    sx,
    OptionProps,
    ...restProps
}: CountryFilterProps) => {
    const props = {
        ...restProps,
        OptionProps: {
            mode: 'iso2' as const,
            ...OptionProps
        },
        sx: {
            width: 300,
            ...sx
        }
    };

    const {
        value,
        getOptionLabel,
        handleChange
    } = useAdapter({
        ...props,
        key: props.OptionProps.mode,
        value: props.value.map(getOptionId),
        onChange: (_, values) => props.onChange({
            type: props.id,
            payload: when(
                props.multiple,
                () => convertToOptions(values),
                () => convertToOptions(values).at(0)
            )
        })
    });

    return (
        <CountrySelector
            size='small'
            {...props}
            value={value}
            getOptionLabel={getOptionLabel}
            onChange={handleChange}
        />
    );
};

export default memo(CountryFilter);
